import React from 'react';
import { Field } from 'react-final-form';

// @ts-ignore
import RenderDropdown from 'forms/RenderDropdown';
import VarietyOptions from 'components/VarietyOptions';

interface OwnProps {
    name: string;
    validate?: any;
    multiple?: boolean;
    nullOnUnmount?: boolean;
    disabled?: boolean;
    placeholder?: string;
    label?: string;
    clearable?: boolean;
}

type Props = OwnProps;

export default class VarietyDropdownField extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            name,
            validate,
            multiple,
            disabled = false,
            nullOnUnmount = false,
            clearable = true,
            placeholder,
            label
        } = this.props;

        return (
            <VarietyOptions>
                <Field
                    component={RenderDropdown as any}
                    subscription={{
                        value: true,
                        touched: true,
                        error: true
                    }}
                    name={name}
                    validate={validate}
                    label={label || 'Variety'}
                    placeholder={placeholder || 'Add a variety'}
                    fluid
                    search
                    selection
                    clearable={clearable}
                    selectOnBlur={false}
                    multiple={multiple}
                    nullOnUnmount={nullOnUnmount}
                    disabled={disabled}
                />
            </VarietyOptions>
        );
    }
}
